export default () => ({
    state: {},
});